import _               from 'underscore';
import { useEffect }   from 'react';
import { SystemEvent } from '../types';

type UseWindowTouchHandlerMethod = ( e: SystemEvent ) => void;

interface UseWindowTouchHook {
	removeWindowTouchListeners: () => void
}

const useWindowTouch = ( handlerMethod: UseWindowTouchHandlerMethod ): UseWindowTouchHook => {
	
	const supportedTouchEvents = [
		'keydown',
		'mousedown'
	];
	
	const addTouchListeners    = () => supportedTouchEvents.map( eventType => document.addEventListener( eventType, handlerMethod ) );
	const removeTouchListeners = () => supportedTouchEvents.map( eventType => document.removeEventListener( eventType, handlerMethod ) );
	
	/* Method to trigger the touch handler */
	const initTouchListener = () => {
		
		if( _.isFunction( handlerMethod ) ){
			
			addTouchListeners()
		}
	}
	
	/* Registration of method on load */
	window.addEventListener( 'load', initTouchListener );
	
	/* Set up the effect of sub/unsub */
	useEffect( () => {
		
		initTouchListener();
		
		return () => {
			
			/* Remove all listeners on unmount */
			removeWindowTouchListeners();
		}
		
	} );
	
	const removeWindowTouchListeners: UseWindowTouchHook['removeWindowTouchListeners'] = () => {
		
		removeTouchListeners()
		
		window.removeEventListener( 'load', initTouchListener );
	}
	
	return {
		removeWindowTouchListeners
	};
}

export { useWindowTouch }
